import React from 'react';
import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<h2>CBSE Board</h2>

<p>St. Andrews World School, Siddharth Vihar offers a CBSE-based curriculum. CBSE is considered to be the most studied curriculum throughout India, so it is a wise decision for the students to study from a CBSE board. There are several benefits attached to the CBSE curriculum we offer:</p>

<ul>
<li><strong>Holistic Skills:</strong> We help the students develop holistic skills through evaluation based on co-scholastic activities.</li>
<li><strong>Traditional Values:</strong> The traditional values are interwoven into the curriculum.</li>
<li><strong>Child-Centric Paradigms:</strong> The student-friendly and child-centric paradigms make the learning experience for the students innovative and fun.</li>
<li><strong>Value-Based Exams:</strong> Examinations are focused both on academics and values.</li>
<li><strong>Technical Knowledge:</strong> The students develop technical knowledge and skills essential for job-oriented inputs.</li>
</ul>`;

const CbseBoard = () => {
  const title = 'CBSE Board';
  const pageData = usePage('cbse-board', { content: DEFAULT_CONTENT });

  return (
    <>
      <SEO
        title={title}
        description="CBSE Board curriculum benefits at St. Andrews World School, Siddharth Vihar."
        keywords="CBSE Board, CBSE school Siddharth Vihar, SAWS Siddharth Vihar"
      />

      <section className="page-hero">
        {!pageData.loading && (
        <img
            src={pageData.bannerImage || `${process.env.PUBLIC_URL}/images/page-banners/curricullam-infrastructure.jpg`}
            alt={title}
            className="page-hero-img"
            loading="eager"
          />
        )}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default CbseBoard;